
import { makeStyles } from 'tss-react/mui';

export const useNavigationBarContainerStyles = makeStyles()(
  ({ spacing, defaultShadow, majorContainerBorderRadius }) => ({
    container: {
      padding: spacing(3),
      display: 'flex',
      alignItems: 'center',
      marginBottom: spacing(3),
      boxShadow: defaultShadow,
      borderRadius: majorContainerBorderRadius,
    },
    mainViewSelect: {
      marginRight: spacing(3),
      '& > div': {
        width: 180,
      },
    },
  })
);

export const useCompanyNavigationBarStyles = makeStyles()(
  ({ spacing }) => ({
    subViewSelect: {
      '& > div': {
        width: 180,
      },
    },
    subViewItem: {
      paddingLeft: spacing(5),
    },
  })
);

export const useNavigationBarSubNavStyles = makeStyles()(
  ({ spacing, palette }) => ({
    container: {
      paddingLeft: spacing(3),
      display: 'flex',
    },
    link: {
      marginRight: spacing(1),
      paddingRight: spacing(1),
      '&:not(:last-child)': {
        borderRight: '1px solid rgba(0, 0, 0, 0.3)',
      },
    },
  })
);
